/**
 * USER API
 * Namespace: User
 */

export const UserApi = {
  accesstoken: [
    {
      name: 'sign',
      method: 'POST',
      path: '/wechat/accesstoken/sign',
      mockPath: '/wechat/accesstoken/sign',
      params: {},
      desc: '1.3 微信token获取'
    },
    {
      name: 'tokenAnOpendId',
      method: 'POST',
      path: '/api/user/tokenAnOpendId',
      mockPath: '/api/user/tokenAnOpendId',
      params: {},
      desc: '1.6 获取网页授权的access_token 和openId'
    },
    {
      name: 'userInfo',
      method: 'POST',
      path: '/api/user/userInfo',
      mockPath: '/api/user/userInfo',
      params: {},
      desc: '1.7 获取用户基本信息（包括UnionID机制）'
    },
    {
      name: 'jsApi',
      method: 'POST',
      path: '/api/appClient/noAuth/wechat/v1/getJsApiSign',
      mockPath: '/api/appClient/noAuth/wechat/v1/getJsApiSign',
      params: {},
      desc: '获取微信公众号JS-api签名'
    }
    
  ]
}

